<div mat-dialog-content>
    <mat-tab-group dynamicHeight (selectedIndexChange)="changeTab($event)">
        <mat-tab label="Create new slider item">
            <form [formGroup]="sliderForm">
                <mat-form-field appearance="fill">
                    <mat-label>{{'Slider type' | translate}}</mat-label>
                    <mat-select [formControl]="typeitem">
                        <mat-option [value]="'image'">
                            {{'Image' | translate}}
                        </mat-option>
                        <mat-option [value]="'promo'">
                            {{'Promo' | translate}}
                        </mat-option>
                        <mat-option [value]="'link'">
                            {{'Link' | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{'Title' | translate}}</mat-label>
                    <input matInput [formControl]="title">
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{'Sub title' | translate}}</mat-label>
                    <input matInput [formControl]="subtitle">
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{'Description' | translate}}</mat-label>
                    <input matInput [formControl]="description">
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>
                        <ng-container *ngIf="data && data.sliderType === 'link'">
                            {{'Link url' | translate}}
                        </ng-container>
                        <ng-template>
                            {{'Content' | translate}}
                        </ng-template>
                    </mat-label>
                    <input matInput [formControl]="content">
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{'Position' | translate}}</mat-label>
                    <input matInput type="number" [formControl]="position">
                </mat-form-field>

                <div *ngIf="data && data.image && data.typeitem && data.typeitem === 'image'">
                    <img [src]="IMAGES_URL + data.image" alt="" width="255px">
                </div>
                <p>
                    <input type="file" accept='image/jpeg, image/png' (change)="onFileChanged($event)" #fileInput>
                </p>
                <div style="display: flex;flex-direction: column;">
                    <i>*Width & heights - any</i>
                    <i>*Width & heights ratio - 340x226</i>
                </div>

                <button mat-raised-button color="primary" (click)="addItem()" [disabled]="sliderForm.invalid">
                    <ng-container *ngIf="!data || !data.id">
                        {{'Add item' | translate}}
                    </ng-container>
                    <ng-container *ngIf="data && data.id">
                        {{'Update item' | translate}}
                    </ng-container>
                </button>
            </form>
        </mat-tab>
        <mat-tab label="Select exists item" *ngIf="!data || !data.id">
            <ng-container *ngIf="categoriesSandbox.getSliderListLoading$ | async">
                <p>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </p>
            </ng-container>
            <ng-container *ngIf="!(categoriesSandbox.getSliderListLoading$ | async)">
                <mat-list>
                    <mat-list-item *ngFor="let item of sliderList">
                        <div class="list-item">
                            <a (click)="selectItem(item)">
                                #{{item.id}} {{item.title}} ({{item.subtitle}})
                            </a>
                            <span (click)="removeItem(item)" class="remove" matTooltip="remove item from server">
                                <mat-icon>close</mat-icon>
                            </span>
                        </div>
                    </mat-list-item>
                </mat-list>
                <i *ngIf="!sliderList || !sliderList.length">{{'No items' | translate}}...</i>
            </ng-container>
        </mat-tab>
    </mat-tab-group>
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
</div>